import { SVGProps, Ref, forwardRef } from 'react';

export const RocketFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M2.67 11.17c1.195 0 2.164.969 2.164 2.163 0 2.423-2.652 2.162-4.325 2.162 0-1.673-.262-4.325 2.162-4.325"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.557 4.507C7.904 2.885 11.229-.083 15.399.6c.685 4.17-2.284 7.495-3.906 8.843.274 2.244-.557 4.46-3.225 6.057-.095-1.327-.374-2.502-.837-3.51l-.647.332-3.106-3.106.333-.647C3.015 8.112 1.844 7.83.5 7.732c1.597-2.668 3.813-3.498 6.057-3.225M10 4.734c-.461 0-.783.155-.987.4-.202.243-.279.56-.279.866l.003.115c.018.27.098.54.275.751.204.245.527.4.988.4l.167-.006c.373-.034.642-.18.821-.394.177-.212.258-.482.276-.75L11.267 6c0-.306-.077-.624-.279-.866-.179-.215-.448-.36-.821-.393z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
RocketFilledSize16Glyph.displayName = 'RocketFilledSize16Glyph';
